export default __webpack_public_path__ + "static/media/axiance-mobile.f139c1f4.png";